import styled from 'styled-components';

export const InclusionLists = styled.ul`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 1.8rem;
    grid-column-gap: 1rem;
    > li{
        position: relative;
        padding-left: 2rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    }
    > li:before{
        content: '';
        display: block;
        width: 0.5rem;
        height: 1rem;
        border: solid #2bac36;
        border-width: 0 0.2rem 0.2rem 0;
        transform: rotate(45deg);
        flex-shrink: 0;
        position: absolute;
        left: 0.2rem;
        top: 0.2rem;
    }
`;